import { render, staticRenderFns } from "./TranslationModal.vue?vue&type=template&id=14f64c72&scoped=true"
import script from "./TranslationModal.vue?vue&type=script&lang=js"
export * from "./TranslationModal.vue?vue&type=script&lang=js"
import style0 from "./TranslationModal.vue?vue&type=style&index=0&id=14f64c72&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f64c72",
  null
  
)

export default component.exports